/*
 *
 * Workspace plugins reducers
 *
 */

import { fromJS } from 'immutable';
import * as constants from './constants';

const initialState = {
  plugins: undefined,
  pluginVersions: {},
  creatingPlugin: false,
  pluginDetails: {},
};

function workspacePluginsReducer(state = fromJS(initialState), action) {
  switch (action.type) {
    case constants.SET_PLUGIN_LIST:
      return state
        .set('plugins', action.plugins);
    case constants.SET_PLUGIN_COLLABORATOR_SUMMARY:
      return getUpdatedStateWithDetails(state, action.pluginId, { collaborators: action.collaborators });
    case constants.SET_PLUGIN_DETAILS:
      return getUpdatedStateWithDetails(state, action.pluginDetails.summary.pluginId, action.pluginDetails);
    case constants.SET_PLUGIN_VERSION_LIST:
      return state
        .setIn(['pluginVersions', action.pluginId], action.versionList);
    case constants.PLUGIN_CREATE_REQUEST:
      return state
        .set('creatingPlugin', true);
    case constants.PLUGIN_CREATE_SUCCESS:
      return state
        .update('plugins', (plugins) => plugins ? [...plugins, action.plugin] : [action.plugin])
        .set('creatingPlugin', false);
    case constants.PLUGIN_CREATE_ERROR:
      return state
        .set('creatingPlugin', false);
    default:
      return state;
  }
}

const getUpdatedStateWithDetails = (state, pluginId, detailsToUpdate) => {
  const existingPluginDetails = state.getIn(['pluginDetails', pluginId]);
  const updatedPluginDetails = { ...existingPluginDetails, ...detailsToUpdate };
  return state.setIn(['pluginDetails', pluginId], updatedPluginDetails);
};

export {
  initialState,
};

export default workspacePluginsReducer;
